import { createContext } from 'react';
import type { AuthState, AuthActions } from 'types';

const AuthStateContext = createContext<AuthState | undefined>(undefined);
const AuthActionsContext = createContext<AuthActions | undefined>(undefined);

export { AuthActionsContext, AuthStateContext };
